import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetOrderEmailSettingsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrderEmailSettingsDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrderEmailSettingsDocumentSortInput> | Types.OrderEmailSettingsDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderEmailSettingsQuery = { __typename?: 'Query', orderEmailSettings?: { __typename?: 'OrderEmailSettingsConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrderEmailSettingsDocument', tenantId: string, docType: Types.OrderEmailDocType, emailSubject?: string | null, emailBody?: string | null, senderId?: string | null, recipients: Array<string>, includeSalesPersonCc: boolean, includeServicingSiteManagerCc: boolean, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type OrderEmailSettingsEnablementFragment = { __typename?: 'OrderEmailSettingsData', tenantId: string, docType: Types.OrderEmailDocType, enabled: boolean, channel: Types.OrderEmailChannel };

export const OrderEmailSettingsEnablementFragmentDoc = new TypedDocumentString(`
    fragment OrderEmailSettingsEnablement on OrderEmailSettingsData {
  tenantId
  docType
  enabled
  channel
}
    `, {"fragmentName":"OrderEmailSettingsEnablement"});
export const GetOrderEmailSettingsDocument = new TypedDocumentString(`
    query GetOrderEmailSettings($where: OrderEmailSettingsDocumentFilterInput, $order: [OrderEmailSettingsDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orderEmailSettings(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      tenantId
      docType
      emailSubject
      emailBody
      senderId
      recipients
      includeSalesPersonCc
      includeServicingSiteManagerCc
      updatedBy
      updatedAt
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOrderEmailSettings: build.query<GetOrderEmailSettingsQuery, GetOrderEmailSettingsQueryVariables | void>({
      query: (variables) => ({ document: GetOrderEmailSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOrderEmailSettingsQuery, useLazyGetOrderEmailSettingsQuery } = injectedRtkApi;
